import(/* webpackMode: "eager" */ "/opt/build/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/opt/build/repo/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/opt/build/repo/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeadFormPopup"] */ "/opt/build/repo/components/LeadFormPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaPixel"] */ "/opt/build/repo/components/MetaPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-dm-sans\",\"display\":\"swap\"}],\"variableName\":\"dmSans\"}");
